import {RelativeTime} from '@primer/react'
import type {ReactNode} from 'react'
import {formatDuration} from '../../../utils/format-duration'
import type {ToolLogMetadataBag} from '../../../types/tool-log-metadata'
import styles from './Tool.module.css'

/**
 * Builds the duration suffix shown after a setup tool's title: a static formatted
 * duration for completed tools, or a live elapsed timer for in-progress ones —
 * matching the pattern GitHub Actions uses for running jobs. Returns undefined when
 * there is no duration or start timestamp to display.
 */
export function buildToolDurationSuffix(
  metadata: ToolLogMetadataBag | undefined,
  isPending: boolean,
): ReactNode | undefined {
  const duration = metadata?.duration
  if (duration !== undefined && duration >= 0) {
    return (
      <span className={styles.toolDuration}>
        <span className={styles.toolDurationDot} aria-hidden="true">
          ·
        </span>
        {formatDuration(duration)}
      </span>
    )
  }

  if (isPending && metadata?.startedAt) {
    return (
      <span className={styles.toolDuration}>
        <span className={styles.toolDurationDot} aria-hidden="true">
          ·
        </span>
        <RelativeTime noTitle format="elapsed" datetime={metadata.startedAt} />
      </span>
    )
  }

  return undefined
}
